import React from 'react';
import { Box, Button, Grid2, Alert } from '@mui/material';
import { Formik, Form } from 'formik';
import { useAuth } from '../../context/AuthProvider';
import axios from 'axios';
import { base_url } from '../../config/urls';
import md5 from 'md5';
import useMediaQuery from '@mui/material/useMediaQuery';

// COMPONENTES
import MyTextInput from '../../components/inputs/MyTextInput';
import MyPasswordInput from '../../components/inputs/MyPasswordInput';

const Login = () => {

    const { logIn } = useAuth();

    // ===============================================
    // VALIDAR SI SE VE DESDE UN MOVIL
    // ===============================================

    const isNonMobile = useMediaQuery("(min-width:600px)");

    // ===============================================
    // ESTADO PARA CONTROLAR ALERTA
    // ===============================================

    const [alert, setAlert] = React.useState({

        show: false,
        text: '',

    });

    const diccionarioErrores = {

        1: 'El usuario no existe',
        2: 'Contraseña incorrecta',
        3: 'Usuario desactivado'

    }

    // ===============================================
    // FUNCION PARA HACER SUBMIT
    // ===============================================

    const handleSubmit = ( values ) => {

        // VALIDAMOS QUE LOS CAMPOS NO ESTEN VACIOS

        if(values.user === '' || values.password === ''){

            setAlert({
                show: true,
                text: 'Ingrese usuario y contraseña para continuar.'
            });

            return;

        }

        // ENCRIPTAMOS LA CONTRASEÑA
        //values.password = md5(values.password);

        // PETICION PARA INICIAR SESION

        axios.post(`${base_url}/usuarios/login`, values).then( response => {

            // SI LA RESPUESTA TRAE UN ERROR MOSTRAMOS LA ALERTA

            if(!response.data.success){

                setAlert({
                    show: true,
                    text: diccionarioErrores[response.data.error]
                });

                return;

            }

            // SI NO HAY ERRORES INICIAMOS SESION

            logIn(response.data.data);

        }).catch( error => {

            console.log(error);

        });

    }

    // ===============================================

    return (

        <Box 
            sx={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,184,255,1) 100%)'
            }}
        >

            <Box
                sx={{
                    width: isNonMobile ? '30%' : '90%',
                    height: isNonMobile ? '55vh' : '50%',
                    backgroundColor: 'white',
                    borderTopRightRadius: '20px',
                    borderBottomLeftRadius: '20px',
                }}
            >

                <Grid2 container>

                    {/* LOGO */}

                    {/* <Grid2 
                        size={12} 
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 3
                        }}
                    >

                        <img
                            src={LogoJw}
                            alt='jw Logo' 
                            width={100} 
                            height={100}
                        />

                    </Grid2>

                    */}

                    {/* AREA PARA FORMULARIO */}

                    <Grid2 size={12}>

                        {/* FORMULARIO PARA LOGIN */}

                        <Formik
                            initialValues={{
                                user: '',
                                password: ''
                            }}
                            onSubmit={(values) => handleSubmit(values) }
                        >

                            <Form>

                                <Grid2 
                                    container 
                                    spacing={3}
                                    padding={4}
                                >

                                    {/* INPUT PARA USER */}

                                    <Grid2 size={12}>

                                        <MyTextInput
                                            name='user'
                                            label='Usuario'
                                        />

                                    </Grid2>

                                    {/* INPUT PARA PASSWORD */}

                                    <Grid2 size={12}>

                                        <MyPasswordInput
                                            name='password'
                                            label='Contraseña'
                                        />

                                    </Grid2>

                                    {/* BOTON PARA SUBMIT */}

                                    <Grid2 
                                        size={12} 
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <Button
                                            variant="contained"
                                            type="submit"
                                            sx={{
                                                backgroundColor: '#4A6DA7',
                                                padding: 1
                                            }}
                                        >
                                            Iniciar Sesion
                                        </Button>

                                    </Grid2>

                                </Grid2>

                            </Form>

                        </Formik>

                    </Grid2>

                    {/* ALERTA */}

                    {
                        alert.show &&

                        <Alert 
                            severity="warning" 
                            variant="filled"
                            sx={{
                                width: '100%',
                                marginTop: 4
                            }}
                        >
                            {alert.text}
                        </Alert>
                    }

                </Grid2>

            </Box>

        </Box>

    )

}

export default Login